// extracted by mini-css-extract-plugin
export default {"container":"getMoveStopsNotificationNode_container__+1rw5","secondary":"getMoveStopsNotificationNode_secondary__RGotg"};